import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import { deleteRelationshipNote } from "../requests/deleteRelationshipNote";
import { getRelationshipNoteDetailsKeyMaker } from "./useGetRelationshipNoteDetails";
import { getRelationshipNotesKeyMaker } from "./useGetRelationshipNotes";
const useDeleteRelationshipNote = (config) => {
    const queryClient = useQueryClient();
    const IDEMPOTENCY_DESCRIPTOR = "delete-relationship-note";
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const mutation = useMutation({
        mutationFn: async ({ advisorId, noteId }) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return deleteRelationshipNote(advisorId, noteId, idempotencyKey, config);
        },
        onSuccess: (data, variables) => {
            // Invalidate notes list queries
            queryClient.invalidateQueries({
                queryKey: getRelationshipNotesKeyMaker(null),
            });
            // Invalidate the specific note details query
            queryClient.removeQueries({
                queryKey: getRelationshipNoteDetailsKeyMaker({
                    advisorId: variables.advisorId,
                    noteId: variables.noteId,
                }),
            });
        },
        onSettled: () => {
            // Generate new idempotency key for next request
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation.mutateAsync;
};
export default useDeleteRelationshipNote;
//# sourceMappingURL=useDeleteRelationshipNote.js.map